import { MainArea, Page, TopArea } from '@salecycle/ui-component-library';
import AppTopBar from 'core/ui/components/AppTopBar/AppTopBar';
import * as React from 'react';
import { NewSftpUserProvider } from '../context/useNewSftpUserContext';
import NewSftpUserWizard from './NewSftpUserWizard';

export const NewSftpUserWizardPage: React.FC = () => (
  <NewSftpUserProvider>
    <MainArea>
      <TopArea>
        <AppTopBar />
      </TopArea>

      <Page padding={0}>
        <NewSftpUserWizard />
      </Page>
    </MainArea>
  </NewSftpUserProvider>
);

export default NewSftpUserWizardPage;
